import { graphql } from "@/gql";
import { ResultOf } from "@graphql-typed-document-node/core";
import { QueryThreadMessagesOrderByColumn, SortOrder } from "@/gql/graphql";

/**
 * Shared so the messages hook and the notes hook write their optimistic rows
 * into the page the other one is reading.
 */
export function threadMessagesVariables(threadId: string) {
  return {
    first: 20,
    thread_id: threadId,
    orderBy: [
      {
        column: QueryThreadMessagesOrderByColumn.CreatedAt,
        order: SortOrder.Desc,
      },
    ],
  };
}

export const threadMessagesQuery = graphql(`
  query ThreadMessages(
    $thread_id: String!
    $first: Int!
    $page: Int
    $orderBy: [QueryThreadMessagesOrderByOrderByClause!]
  ) {
    threadMessages(
      thread_id: $thread_id
      first: $first
      page: $page
      orderBy: $orderBy
    ) {
      data {
        ...ThreadMessageFields
      }
      paginatorInfo {
        currentPage
        hasMorePages
      }
    }
  }
`);

export type ThreadMessageFragment = NonNullable<
  ResultOf<typeof threadMessageFragment>
>;

export const threadMessageFragment = graphql(`
  fragment ThreadMessageFields on ThreadMessage {
    id
    thread_id
    user_id
    organisation_id
    body
    is_admin_note
    created_at
    user {
      id
      name
      profilePicture {
        ...MediaFields
      }
    }
    organisation {
      id
      name
      profilePicture {
        ...MediaFields
      }
    }
    attachments {
      ...MediaFields
    }
  }
`);
